import {DefaultEventsMap, EventDataType, EventID, Listener} from '@gongxigames/framework/core/types/IEventManager';

export type EventMap = Record<EventID, Listener[]>;

export interface Event {
    id: EventID;
    args: any[];
}

export interface IAsyncEventDecorator<EventsMap = DefaultEventsMap> {

    asyncEventMap: EventMap;

    dispatchAsyncEvents(): void;

    addEvent<K extends keyof EventsMap>(id: K, ...args: EventDataType<EventsMap[K]>): void;
}
